// extracted by mini-css-extract-plugin
export default {"sortableList":"sortableList_sortableList__+HoXe"};